import type { DenetimBulguTuru } from "@/api/denetim";
import type { TrKey } from "@/i18n";

/**
 * Backend (`app/audit/catalog.py`) bulgu kayitlarina "siddet" alani EKLEMEZ —
 * bu istemci-tarafi bir siniflandirma (docstring gerekcesiyle: eksik_ozellik/
 * rozet_uyusmazlik dogrudan yanlis/eksik bilgi riski tasir → yuksek; celiski
 * insan kontrolu gerektiren bir veri hatasi → orta; gri_alan sadece bir
 * olasilik/insan karari → dusuk).
 */
export type Siddet = "yuksek" | "orta" | "dusuk";

export const SIDDET_BY_TUR: Record<DenetimBulguTuru, Siddet> = {
  eksik_ozellik: "yuksek",
  rozet_uyusmazlik: "yuksek",
  celiski: "orta",
  gri_alan: "dusuk",
};

export const TUR_LABEL_KEY: Record<DenetimBulguTuru, TrKey> = {
  eksik_ozellik: "denetim.tur.eksik_ozellik",
  rozet_uyusmazlik: "denetim.tur.rozet_uyusmazlik",
  celiski: "denetim.tur.celiski",
  gri_alan: "denetim.tur.gri_alan",
};

export const SIDDET_LABEL_KEY: Record<Siddet, TrKey> = {
  yuksek: "denetim.siddet.yuksek",
  orta: "denetim.siddet.orta",
  dusuk: "denetim.siddet.dusuk",
};

export const SIDDET_ORDER: Record<Siddet, number> = { yuksek: 0, orta: 1, dusuk: 2 };
export const SIDDET_SECENEKLERI: Siddet[] = ["yuksek", "orta", "dusuk"];
